import {db} from "@/firebase"

const project_messages_ref = db.collection("project_messages");

const PromisesOfMessagesAndComments = (querySnapshot) => {
    return querySnapshot.docs.map((doc) => {
        const commentsRef = doc.ref.collection('comments').orderBy('created_at', 'desc');
        return {
            docRef: doc.ref,
            commentsRef: commentsRef
        };
    });
};
const resolveMessagesAndCommentsPromises = async (querySnapshot) => {
    const pendingMessagesPromises = PromisesOfMessagesAndComments(querySnapshot);
    const resolvedPromises = await Promise.all(pendingMessagesPromises.map(item => Promise.all([item.docRef.get(), item.commentsRef.get()])))

    return resolvedPromises.map(([docSnap, commentsSnap]) => {
        return {
            ...docSnap.data(),
            comments: commentsSnap.docs.map(c => c.data())
        };
    });
}
const addReaderToMessages = async (messageIds, readerId) => {
    const updatePromises = [];

    for (const messageId of messageIds) {
        const messageRef = project_messages_ref.doc(messageId);

        const messageSnap = await messageRef.get();

        if (!messageSnap.exists) {
            console.error(`Mensagem ${messageId} não existe.`);
            continue;
        }

        const messageData = messageSnap.data();
        const currentReader = {
            reader_id: readerId,
            read_at: new Date()
        };

        if (!messageData.readers?.some(reader => reader.reader_id === readerId)) {
            const newReaders = [...(messageData.readers || []), currentReader];

            updatePromises.push(
                messageRef.update({ readers: newReaders })
            );
        }

        const commentsRef = messageRef.collection('comments');
        const commentsSnap = await commentsRef.get();

        commentsSnap.forEach(commentDoc => {
            const commentData = commentDoc.data();

            if (!commentData.readers?.some(reader =>reader.reader_id === readerId)) {
                const newCommentReaders = [...(commentData.readers || []), currentReader];
                updatePromises.push(
                    commentDoc.ref.update({ readers: newCommentReaders })
                );
            }
        });
    }

    await Promise.all(updatePromises);

    return true;
}
const createMessage = async (message) => {
    try {
        const result = await project_messages_ref.add(message);
        await result.update({id_doc: result.id})
        return result.id;
    } catch (error) {
        throw new Error("createMessage Fail!" + error)
    }
}
const getAllMessagesByProject = async (id_project) => {
    try {
        const querySnapshot = await project_messages_ref
            .where('id_project', '==', id_project)
            .orderBy('created_at', 'desc')
            .get();

        let messages = [];

        if (querySnapshot.empty) {
            return [];
        }

        messages = resolveMessagesAndCommentsPromises(querySnapshot);

        return messages;
    } catch (error) {
        console.error("Erro ao buscar mensagens:", error);
        throw new Error("getAllMessagesByProject Fail: " + error.message);
    }
};
const getAllMessages = async () => {
    try {
        let messages = [];

        const querySnapshot = await project_messages_ref.get();

        messages = resolveMessagesAndCommentsPromises(querySnapshot);

        return messages;
    } catch (error) {
        console.error("Erro ao buscar mensagens:", error);
        throw new Error("getAllMessages Fail: " + error.message);
    }
};
const deleteMessage = async (id_message) => {
    try {
        const batch = db.batch();

        const messageRef = project_messages_ref.doc(id_message);
        batch.delete(messageRef);

        const commentsRef = await  messageRef.collection('comments').get();

        commentsRef.forEach(doc => {
            batch.delete(doc.ref);
        });

        await batch.commit();

    } catch (error) {
        console.error("Erro ao excluir mensagem e comentários:", error);
        throw new Error("deleteMessage Fail: " + error.message);
    }
};
const updateMessage = async (id_message, message) => {
    try {
        const messageRef = project_messages_ref.doc(id_message);
        await messageRef.update({message: message, updated_at: new Date()})
        const messageRefSnapshot = await messageRef.get();

        return [true, messageRefSnapshot.data()];
    } catch (error) {
        console.error("Erro ao criar comentário:", error);
        throw new Error("updateMessage Fail: " + error.message);
    }
}
const createComment = async (comment) => {
    try {
        const messageRef = project_messages_ref.doc(comment.id_message);
        const commentRef = await messageRef.collection('comments').add(comment);
        await commentRef.update({ id_doc: commentRef.id });
        return commentRef.id;
    } catch (error) {
        console.error("Erro ao criar comentário:", error);
        throw new Error("createComment Fail: " + error.message);
    }
};
const deleteComment = async (id_message, id_comment) => {
    try {
        const docRef = project_messages_ref.doc(id_message);
        const docSnap = await docRef.get();

        if (!docSnap.exists) {
            console.log("Mensagem não encontrada");
            return false;
        }

        const commentRef = docRef.collection('comments').doc(id_comment);
        const commentSnap = await commentRef.get();

        if (!commentSnap.exists) {
            console.log("Comentário não encontrado");
            return false;
        }

        await commentRef.delete();
        console.log("Comentário deletado com sucesso");
        return true;

    } catch (error) {
        console.error("Erro ao deletar comentário:", error);
        throw new Error("deleteComment Fail: " + error.message);
    }
};
const updateComment = async (id_message, id_comment, comment) => {
    try {
        const commentRef = project_messages_ref
            .doc(id_message)
            .collection("comments")
            .doc(id_comment);
        await commentRef.update({comment: comment, updated_at: new Date()})
        const commentRefSnapshot = await commentRef.get();
        return [true, commentRefSnapshot.data()];
    } catch (error) {
        console.error("Erro ao criar comentário:", error);
        throw new Error("updateComment Fail: " + error.message);
    }
}


async function paginationCallsMessagesByProject(lastDoc = null, id_project, tag = null) {
    try {
        let messageRef = project_messages_ref
            .where('id_project', '==', id_project)
            .orderBy("created_at", "desc")
            .limit(10);

        if (lastDoc) {
            messageRef = messageRef.startAfter(lastDoc);
        }

        const messagesSnapShot = await messageRef.get();
        let messages = await resolveMessagesAndCommentsPromises(messagesSnapShot);

        // Filtra as mensagens pela tag se ela for fornecida
        if (tag) {
            messages = messages.filter(msg => msg.tag === tag);
        }
        
        const lastDocSnapshot = messagesSnapShot.docs[messagesSnapShot.docs.length - 1];
        return { result: messages.length, messages, lastDocSnapshot };
    } catch (error) {
        console.error('Error getting messages:', error);
        return { result: false, messages: [], lastDocSnapshot: null };
    }
}


export default {
    createMessage,
    getAllMessagesByProject,
    getAllMessages,
    deleteMessage,
    updateMessage,
    createComment,
    deleteComment,
    updateComment,
    addReaderToMessages,
    paginationCallsMessagesByProject,
};